"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLimitedYCoord = exports.HeightResizerDragPreview = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var HeightResizer_1 = require("../Resize/HeightResizer");
var sdk_ui_ext_1 = require("@gooddata/sdk-ui-ext");
var LayoutResizeContext_1 = require("../LayoutResizeContext");
var sizeLimiting_1 = require("./sizeLimiting");
exports.HeightResizerDragPreview = function (props) {
    var item = props.item, initialOffset = props.initialOffset, differenceFromInitialOffset = props.differenceFromInitialOffset, scrollCorrection = props.scrollCorrection, getDragLayerPosition = props.getDragLayerPosition;
    var toggleHeightLimitReached = LayoutResizeContext_1.useResizeHandlers().toggleHeightLimitReached;
    var _a = tslib_1.__read(react_1.useState("none"), 2), hasReachedLimit = _a[0], setReachedLimit = _a[1];
    react_1.useEffect(function () {
        toggleHeightLimitReached(hasReachedLimit);
    }, [hasReachedLimit, toggleHeightLimitReached]);
    var dragLayerOffset = getDragLayerPosition();
    var currentUnlimitedHeightGR = getNewHeightGR(item.widgetHeights, differenceFromInitialOffset.y, scrollCorrection.y);
    react_1.useEffect(function () {
        var hasNowReachedLimit = hasHeightReachedLimit(currentUnlimitedHeightGR, item.minLimit, item.maxLimit);
        if (hasNowReachedLimit !== hasReachedLimit) {
            setReachedLimit(hasNowReachedLimit);
        }
    }, [currentUnlimitedHeightGR, item.minLimit, item.maxLimit, hasReachedLimit]);
    var top = getLimitedYCoord(item, initialOffset.y, differenceFromInitialOffset.y, scrollCorrection.y);
    var style = {
        top: top - dragLayerOffset.y + scrollCorrection.y + "px",
        left: initialOffset.x - dragLayerOffset.x + scrollCorrection.x + "px",
        right: "30px",
    };
    return (react_1.default.createElement("div", { className: "height-resizer-drag-preview s-height-resizer-drag-preview", style: style },
        react_1.default.createElement(HeightResizer_1.HeightResizer, { status: "active" })));
};
function getPrimaryHeightGR(heightsGR) {
    heightsGR = heightsGR || [10];
    return Math.max.apply(Math, tslib_1.__spread(heightsGR));
}
function hasHeightReachedLimit(heightGR, min, max) {
    if (heightGR < min)
        return "min";
    if (heightGR > max)
        return "max";
    return "none";
}
function getNewHeightGR(widgetHeights, offsetYPX, scrollingCorrectionY) {
    var primaryHeightGR = getPrimaryHeightGR(widgetHeights);
    var totalDelta = offsetYPX - scrollingCorrectionY;
    var deltaHeightGR = sdk_ui_ext_1.fluidLayoutDescriptor.toGridHeight(totalDelta);
    return primaryHeightGR + deltaHeightGR;
}
function getLimitedYCoord(item, initialSourceClientOffsetY, differenceFromInitialOffsetY, scrollingCorrectionY) {
    var minLimit = item.minLimit, maxLimit = item.maxLimit;
    var deltaSize = sdk_ui_ext_1.fluidLayoutDescriptor.toGridHeight(differenceFromInitialOffsetY - scrollingCorrectionY);
    var curPrimaryHeightGR = getPrimaryHeightGR(item.widgetHeights);
    var newSizeLimited = sizeLimiting_1.getLimitedSize(minLimit, maxLimit, curPrimaryHeightGR, deltaSize);
    var deltaY = sdk_ui_ext_1.fluidLayoutDescriptor.toHeightInPx(newSizeLimited - curPrimaryHeightGR);
    return initialSourceClientOffsetY + deltaY;
}
exports.getLimitedYCoord = getLimitedYCoord;
//# sourceMappingURL=HeightResizerDragPreview.js.map